import { render, staticRenderFns } from "./d-search-result.vue?vue&type=template&id=228682ee&"
import script from "./d-search-result.vue?vue&type=script&lang=js&"
export * from "./d-search-result.vue?vue&type=script&lang=js&"
import style0 from "./d-search-result.vue?vue&type=style&index=0&id=228682ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports